export type SecondsToHMSOptions = {
  includeHours?: 'auto' | 'always' | 'never';
  includeMilliseconds?: boolean;
  millisecondsPrecision?: number;
};

export function secondsToHMS(
  seconds: number,
  options: SecondsToHMSOptions = {
    includeHours: 'auto',
    includeMilliseconds: false,
    millisecondsPrecision: 3,
  },
) {
  const { includeHours = 'auto', includeMilliseconds = false, millisecondsPrecision = 3 } = options;

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  const milliseconds = seconds % 1;

  let text = '';
  if (includeHours === 'always' || (hours > 0 && includeHours === 'auto')) {
    text += `${hours.toString().padStart(2, '0')}:`;
  }
  text += `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;

  if (includeMilliseconds) {
    const precision = 10 ** millisecondsPrecision;
    text += `.${Math.floor(milliseconds * precision)
      .toString()
      .padStart(millisecondsPrecision, '0')}`;
  }

  return text;
}

export function hmsToSeconds(hms: string) {
  const atoms = hms.split(':').map((x) => parseFloat(x));

  const seconds = atoms.pop() || 0;
  const minutes = atoms.pop() || 0;
  const hours = atoms.pop() || 0;

  return hours * 3600 + minutes * 60 + seconds;
}

export function isValidHMS(hms: string) {
  if (!hms.trim()) return false;
  return /^(?:[0-9]+:){0,2}[0-9]+(?:\.[0-9]+)?$/.test(hms);
}

export const SECOND = 1000;
export const MINUTE = 60 * SECOND;
export const HOUR = 60 * MINUTE;
export const DAY = 24 * HOUR;
export const WEEK = 7 * DAY;
